import React from "react";
import seoRoutes from "../../../generated/seoRoutes";

function isReactSnap() {
  return typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent || "");
}

function PrerenderCrawlerLinks() {
  if (!isReactSnap()) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        width: 0,
        height: 0,
        overflow: "hidden",
        opacity: 0,
        pointerEvents: "none",
      }}
    >
      {seoRoutes.map((route) => (
        <a key={route} href={route}>
          {route}
        </a>
      ))}
    </div>
  );
}

export default PrerenderCrawlerLinks;
